import { render, staticRenderFns } from "./default_dashboard.vue?vue&type=template&id=4baf2b78&scoped=true&"
import script from "./default_dashboard.vue?vue&type=script&lang=js&"
export * from "./default_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./default_dashboard.vue?vue&type=style&index=0&id=4baf2b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf2b78",
  null
  
)

export default component.exports